import $ from 'jquery';
const contactForm = {
	init: function () {
		const openModalButton = $('.js-open-form-modal');
		openModalButton.each(
			function () {
				const button = $(this);
				if (button.hasClass('js-open-insurance-modal')) {
					return;
				}
				const modalType = button.attr('data-modal');
				const modal = $(`.${modalType}`);
				const closeModalButton = modal.find('.js-close-contact-form-modal');


				button.click(
					function (e) {
						e.preventDefault();
						modal.fadeIn();
						$('body').addClass('modal-open');
						if (modalType === 'js-contact-form-modal' || modalType === 'js-product-form-modal') {
							$('input[name="entry_url"]').val(window.location.href);
							$('input[name="entry_product"]').val(button.attr('data-product'));
						}
						if ($(this).hasClass('js-menu-modal')) {
							console.log('test');
							$('.js-product-form-modal .js-switcher-by-id-navigation-item').eq(1).click();
						}

					}
				);
				closeModalButton.click(
					function (e) {
						e.preventDefault();
						modal.fadeOut();
						$('body').removeClass('modal-open');


					}
				)

			}
		)
		this.thankYouModal()
	},
	thankYouModal() {
		$('.contact-form').each(
			function () {
				let form = $(this).parent().parent(),
					content,
					modal_thankyou = $(form).next('.thankyou-modal'),
					cf_switch = $(this).find('.contact-form__navigation-item.active'),
					contact_type = $(cf_switch).find('.value-option').val();

				const switcher = $(this).find('.js-switcher-navigation-item');

				if (switcher) {
					switcher.click(
						function () {
							contact_type = $(this).find('.value-option').val();
						}
					)
				}

				$(form).on(
					'wpcf7mailsent',
					function () {

						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({
							'event': 'form submitted',
							'submit_id': Date.now().toString()
						});

						const hrefUrl = new URL(window.location.href);
						const hrefCampaignValue = hrefUrl.searchParams.get('utm_campaign');
						if (window.hrefCampaignValueFound && window.hrefCampaignValueFound === hrefCampaignValue) {
							if (typeof fbq === 'function') {
								fbq('track', 'Contact')
							}
						}



						const closeModalButton = modal_thankyou.find('.js-close-contact-form-modal');

						if ($(this).find('.contact-form').hasClass('contact-form--callback') || $(this).find('.contact-form').hasClass('contact-form--product')) {
							if (contact_type === 'choosen-date') {
								content = '<p>Dziękujemy za wypełnienie formularza.</p>'
								content += '<p>Zadzwonimy do Ciebie w wybranym terminie.</p>'
							} else {
								content = '<p>Dziękujemy za wypełnienie formularza. Skontaktujemy się z Tobą jak najszybciej.</p>'
								content += '<p>Pracujemy od poniedziałku do piątku w godzinach od 8:00 do 18:00</p>'
							}
						} else {
							content = '<p>Dziękujemy za wypełnienie formularza.</p>'
						}

						$(
							'<div />',
							{
								class: 'thankyou-modal__text-wrapper',
								html: content,
							}
						).appendTo(modal_thankyou.find('.thankyou-modal__content'));

						modal_thankyou.fadeIn();

						closeModalButton.click(
							function (e) {
								e.preventDefault();
								modal_thankyou.fadeOut();
								setTimeout(function () { modal_thankyou.find('.thankyou-modal__content .thankyou-modal__text-wrapper').remove() }, 500)
							}
						)

					}
				)
			}
		)
	}
}
export default contactForm;
